<div style="margin-top: 1em">
  <p-card>
    <ng-template pTemplate="title"> Информация об авторе(-ах) </ng-template>
    <ng-template pTemplate="subtitle"> Введите информацию о себе</ng-template>
    <br />
    <ng-template pTemplate="content">
      <form [formGroup]="authorsForm">
        <div class="container-fluid">
          <div class="grid">
            <div class="col-12 sm:col-12 md:col-4 lg:col-4 xl:col-4 mb-3">
              <span class="p-float-label">
                <input
                  id="lastName-float"
                  type="text"
                  pInputText
                  class="container-fluid w-full"
                  formControlName="lastNameCtrl"
                  autocomplete="family-name"
                />
                <label for="lastName-float">Фамилия</label>
              </span>
              <div
                *ngIf="
                  authorsForm.controls['lastNameCtrl'].invalid &&
                  authorsForm.controls['lastNameCtrl'].touched
                "
              >
                <small id="username2-help" class="p-error"
                  >Поле не должно быть пустым!</small
                >
              </div>
            </div>

            <div class="col-12 sm:col-12 md:col-4 lg:col-4 xl:col-4  mb-3">
              <span class="p-float-label">
                <input
                  id="firstName-float"
                  type="text"
                  pInputText
                  class="container-fluid w-full"
                  formControlName="firstNameCtrl"
                  autocomplete="given-name"
                />
                <label for="firstName-float">Имя</label>
              </span>
              <div
                *ngIf="
                  authorsForm.controls['firstNameCtrl'].invalid &&
                  authorsForm.controls['firstNameCtrl'].touched
                "
              >
                <small id="username2-help" class="p-error"
                  >Поле не должно быть пустым!</small
                >
              </div>
            </div>

            <div class="col-12 sm:col-12 md:col-4 lg:col-4 xl:col-4  mb-3">
              <span class="p-float-label">
                <input
                  id="middleName-float"
                  type="text"
                  pInputText
                  class="container-fluid w-full"
                  formControlName="middleNameCtrl"
                  autocomplete="additional-name"
                />
                <label for="middleName-float">Отчество</label>
              </span>
            </div>

            <div class="col-12  mb-3">
              <span class="p-float-label">
                <input
                  id="contactEmail-float"
                  type="text"
                  pInputText
                  class="container-fluid w-full"
                  formControlName="contactEmail"
                  autocomplete="username"
                />
                <label for="contactEmail-float">Email</label>
              </span>
              <div
                *ngIf="
                  authorsForm.controls['contactEmail'].invalid &&
                  authorsForm.controls['contactEmail'].touched
                "
              >
                <small id="username2-help" class="p-error"
                  >Некорректный e-mail адрес!</small
                >
              </div>
            </div>

            <div class="col-12  mb-3">
              <span class="p-float-label">
                <input
                  id="workplace-float"
                  type="text"
                  pInputText
                  class="container-fluid w-full"
                  formControlName="workplace"
                  autocomplete="organization"
                />
                <label for="workplace-float">Место работы</label>
              </span>
              <div *ngIf="hasErr(authorsForm.controls['workplace'], 'required')">
                <small id="workplace-help" class="p-error"
                  >Поле не должно быть пустым!</small
                >
              </div>
              </div>
          </div>
        </div>

        <div formArrayName="otherAuthorsFG" style="border: none;">
          <div
            class="container-fluid"
            style="background-color: #f7f7f7"
            *ngFor="
              let another of getFormAnotherAuthors().controls;
              let idx = index
            "
          >
            <form [formGroupName]="idx" style="padding: 2em; height: 14em">
              <div class="grid align-items-center" style="margin-bottom: 1em">
                <div class="col">
                  <span class="p-float-label">
                    <input
                      id="lastName-float-{{ idx }}"
                      type="text"
                      pInputText
                      class="container-fluid w-full"
                      formControlName="lastNameCtrl"
                    />
                    <label for="lastName-float-{{ idx }}">Фамилия</label>
                  </span>
                </div>

                <div class="col">
                  <span class="p-float-label">
                    <input
                      id="firstName-float-{{ idx }}"
                      type="text"
                      pInputText
                      class="container-fluid w-full"
                      formControlName="firstNameCtrl"
                    />
                    <label for="firstName-float-{{ idx }}">Имя</label>
                  </span>
                </div>

                <div class="col">
                  <span class="p-float-label">
                    <input
                      id="middleName-float-{{ idx }}"
                      type="text"
                      pInputText
                      class="container-fluid w-full"
                      formControlName="middleNameCtrl"
                    />
                    <label for="middleName-float-{{ idx }}">Отчество</label>
                  </span>
                </div>
              </div>

              <div class="align-items-center">
                <div>
                  <span class="p-float-label">
                    <input
                      id="workplace-float-{{ idx }}"
                      type="text"
                      pInputText
                      class="container-fluid w-full"
                      formControlName="workplace"
                    />
                    <label for="workplace-float-{{ idx }}">Место работы</label>
                  </span>
                  <div
                    *ngIf="
                      getFormAnotherAuthorsError(idx, 'workplace', 'required')
                    "
                  >
                    <small id="workplace-float-{{ idx }}-help" class="p-error"
                      >Поле не должно быть пустым!</small
                    >
                  </div>
                </div>

                <div class="mt-2 flex justify-content-end flex-wrap">
                  <span class="p-float-label">
                    <button
                      pButton
                      pRipple
                      type="button"
                      label="Удалить автора"
                      class="p-button-danger"
                      (click)="removeAuthor(idx)"
                    ></button>
                  </span>
                </div>


              </div>
            </form>
          </div>
        </div>

      </form>
    </ng-template>


    <ng-template pTemplate="footer">

      <div class="flex flex-row align-items-center justify-content-between mt-3">
        <button
        pButton
        pRipple
        type="button"
        label="Добавить автора"
        class="p-button-success"
        (click)="addAuthor()"
      ></button>
      <p-button
      label="Далее"
      (onClick)="onSubmit()"
      icon="pi pi-angle-right"
      iconPos="right"
    ></p-button>
      </div>
    </ng-template>

  </p-card>
</div>
